import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ConsignmentTemplateTable from './ConsignmentsTemplatesTable';
const Page = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsx(ConsignmentTemplateTable, {}) }));
};
export default Page;
